<template>
  <iframe
    :class="iframeClass"
    :src="src"
    allow="fullscreen"
  />
</template>

<script setup>
import { onUnmounted } from 'vue';

const props = defineProps({
  src: {
    type: String,
    default: null,
  },
  iframeClass: {
    type: String,
    default: null,
  },
  messageType: {
    type: String,
    default: 'iframe_exit',
  },
});

const emit = defineEmits(['exit']);

function handleMessage(event) {
  if (event.data?.type === props.messageType) {
    emit('exit');
  }
}

onMounted(() => {
  window.addEventListener('message', handleMessage);
});

onUnmounted(() => {
  window.removeEventListener('message', handleMessage);
});
</script>
